
import type { ElementType, ReactNode, HTMLAttributes } from 'react';
import { cx } from '@client/shared/lib/cx.ts';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  pad?: 'none' | 'sm' | 'md' | 'lg';
  raised?: boolean;
  interactive?: boolean;
  spine?: boolean;
  as?: ElementType;
  children?: ReactNode;
}

const padClass = {
  none: styles['pad-none'],
  sm: styles['pad-sm'],
  md: styles['pad-md'],
  lg: styles['pad-lg'],
} as const;

export function Card({
  pad = 'md',
  raised = false,
  interactive = false,
  spine = false,
  as: As = 'div',
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <As
      className={cx(
        styles.card,
        padClass[pad],
        raised && styles.raised,
        interactive && styles.interactive,
        spine && styles.spine,
        className,
      )}
      {...rest}
    >
      {children}
    </As>
  );
}
